import { RequestStates } from '../enums/States';
export function makeStartedRequest() {
  return {
    requestState: RequestStates.STARTED
  };
}
export function makeUninitializedRequest() {
  return {
    requestState: RequestStates.UNINITIALIZED
  };
}
export function makeSucceededRequest() {
  return {
    requestState: RequestStates.SUCCEEDED
  };
}
export function makeFailedRequest(request) {
  return Object.assign({
    requestState: RequestStates.FAILED
  }, request);
}